import { useQuery } from '@tanstack/react-query';
import {
  packagesService,
  TemplateType,
  DocumentTemplateConfig,
  DEFAULT_DOCUMENT_TEMPLATES,
} from '../services/packagesService';

export const documentTemplatesQueryKey = ['document-templates'];

export function useGetDocumentTemplates() {
  return useQuery<Record<TemplateType, DocumentTemplateConfig>>({
    queryKey: documentTemplatesQueryKey,
    queryFn: async () => {
      return packagesService.getDocumentTemplates();
    },
    initialData: DEFAULT_DOCUMENT_TEMPLATES,
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
}
